export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("frietekes_state")
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    console.error("Error in loading the state ", err)
    return undefined
  }
}

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem("frietekes_state", serializedState)
  } catch (err) {
    console.error("Error in saving the state ", err)
  }
}
